import React, { useState } from 'react';

const Card = (props) => {
    let course = props.course;
    let LikedCouses = props.LikedCouses;
    let setLikedCouses = props.setLikedCouses;
    function clickHandler(){
        if(LikedCouses.includes(course.id)){
            setLikedCouses((prev)=>
            prev.filter((c)=> c !== course.id)
            );
        }
        else{
            setLikedCouses((prev)=> [...prev, course.id]);
        }
    }
    return (
        <div className='w-[300px] bg-blue-900 rounded-md overflow-hidden bg-opacity-80'>
            <div className='relative'>
                <img  
            
                src={course.image.url} alt="" />
                <div className='w-[30px] h-[30px] bg-white rounded-full 
                absolute right-2 bottom-2 grid place-items-center
                '>
                    <button className='text-xl' onClick={clickHandler}>
                       🧡
                    </button>
                </div>
            </div>
            <div className='p-4'>
                <p className='text-white font-semibold text-lg'>
                    {course.title}
                </p>
                <p className='text-white   '>
                    {/* {course.description.length > 200 ? course.description.substr} */}
                    {course.description}
                </p>
            </div>
        </div>
    );
}

export default Card;
